var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg"},[(_vm.loaded && _vm.data)?_c('div',{staticClass:"bg"},[(_vm.is2D)?_c('Visit2D',{attrs:{"images":_vm.data.slides}}):_c('Visit360',{attrs:{"data":_vm.data}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }